export function Table({ children, className = '' }) {
  return (
    <div className={`overflow-x-auto rounded-lg border border-slate-200 bg-white ${className}`}>
      <table className="min-w-full text-left text-[13px] leading-tight">
        {children}
      </table>
    </div>
  )
}

export function THead({ children }) {
  return (
    <thead className="bg-slate-50">
      <tr>{children}</tr>
    </thead>
  )
}

export function Th({ children, className = '' }) {
  return (
    <th
      scope="col"
      className={`px-2.5 py-2 text-[11px] font-bold uppercase tracking-[0.06em] text-slate-500 whitespace-nowrap ${className}`}
    >
      {children}
    </th>
  )
}

export function TBody({ children }) {
  return <tbody className="divide-y divide-slate-100 bg-white">{children}</tbody>
}

export function Tr({ children, className = '' }) {
  return (
    <tr className={`transition-colors hover:bg-[#f4f7fb] ${className}`}>
      {children}
    </tr>
  )
}

export function Td({ children, className = '' }) {
  return (
    <td className={`px-2.5 py-[7px] text-slate-700 whitespace-nowrap align-middle ${className}`}>
      {children}
    </td>
  )
}
